import React, { useEffect, useState } from 'react';
import { CardBackSettings, CARDBACK_PRESETS, loadCardBackSettings } from '../../core/cardback';

interface CardBackProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  count?: number;
  customSettings?: CardBackSettings;
}

// 1. 北美高校联盟 (NACUAA) - 常春藤桂冠与启蒙火炬
const NacuaaCrest = () => (
  <svg viewBox="0 0 100 100" fill="none" className="w-full h-full drop-shadow-md">
    <defs>
      <linearGradient id="nacGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FEF08A" />
        <stop offset="50%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#B45309" />
      </linearGradient>
    </defs>
    <circle cx="50" cy="50" r="44" stroke="url(#nacGold)" strokeWidth="1.8" />
    <circle cx="50" cy="50" r="39" stroke="url(#nacGold)" strokeWidth="0.8" strokeDasharray="2 2" />
    <path d="M22 62 C 18 48, 22 32, 34 22 C 32 30, 28 40, 34 46 C 28 50, 26 56, 22 62 Z" fill="url(#nacGold)" />
    <path d="M78 62 C 82 48, 78 32, 66 22 C 68 30, 72 40, 66 46 C 72 50, 74 56, 78 62 Z" fill="url(#nacGold)" />
    <path d="M50 16 C 45 23, 44 29, 48 34 C 49 31, 51 29, 52 30 C 56 26, 56 20, 50 16 Z" fill="url(#nacGold)" />
    <path d="M42 34 L58 34 L54 42 L46 42 Z" fill="url(#nacGold)" />
    <path d="M47 42 L53 42 L51 58 L49 58 Z" fill="url(#nacGold)" />
    <path d="M34 54 C 42 51, 48 53, 50 56 C 52 53, 58 51, 66 54 L 65 62 C 58 59, 52 61, 50 64 C 48 61, 42 59, 35 62 Z" fill="url(#nacGold)" />
    <polygon points="50,68 52,73 57,73 53,76 55,81 50,78 45,81 47,76 43,73 48,73" fill="url(#nacGold)" />
    <circle cx="36" cy="74" r="2" fill="url(#nacGold)" />
    <circle cx="64" cy="74" r="2" fill="url(#nacGold)" />
    <circle cx="28" cy="65" r="1.5" fill="url(#nacGold)" />
    <circle cx="72" cy="65" r="1.5" fill="url(#nacGold)" />
  </svg>
);

// 2. 浙江大学北美校友会 · 浙大智能体 (ZJUAANC) - 求是雄鹰盾徽
const ZjuaancCrest = () => (
  <svg viewBox="0 0 100 100" fill="none" className="w-full h-full drop-shadow-md">
    <defs>
      <linearGradient id="zjuEagleGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#E0F2FE" />
        <stop offset="40%" stopColor="#38BDF8" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
      <linearGradient id="zjuGoldRim" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FEF08A" />
        <stop offset="60%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#B45309" />
      </linearGradient>
    </defs>
    <path d="M50 8 L86 24 L86 62 L50 92 L14 62 L14 24 Z" stroke="url(#zjuGoldRim)" strokeWidth="2" fill="#0C4A6E" fillOpacity="0.6" />
    <path d="M50 14 L80 27 L80 59 L50 85 L20 59 L20 27 Z" stroke="url(#zjuGoldRim)" strokeWidth="0.8" strokeDasharray="2 2" />
    <path d="M50 36 C 42 22, 28 22, 20 28 C 26 34, 34 38, 38 48 C 30 46, 25 50, 24 54 C 32 54, 38 52, 44 56 Z" fill="url(#zjuGoldRim)" />
    <path d="M50 36 C 58 22, 72 22, 80 28 C 74 34, 66 38, 62 48 C 70 46, 75 50, 76 54 C 68 54, 62 52, 56 56 Z" fill="url(#zjuGoldRim)" />
    <path d="M50 25 C 47 28, 48 32, 50 38 C 52 32, 53 28, 50 25 Z" fill="#FFF" />
    <path d="M46 38 L54 38 L50 56 Z" fill="url(#zjuGoldRim)" />
    <polygon points="50,60 56,68 54,78 50,74 46,78 44,68" fill="url(#zjuEagleGold)" />
    <circle cx="50" cy="74" r="2.5" fill="#38BDF8" stroke="url(#zjuGoldRim)" strokeWidth="0.8" />
    <circle cx="38" cy="66" r="2" fill="#38BDF8" />
    <circle cx="62" cy="66" r="2" fill="#38BDF8" />
  </svg>
);

// 3. 唯爱 AI 公益基金会 (VI AI for Good) - 爱心与 AI 科技星
const ViAiCrest = () => (
  <svg viewBox="0 0 100 100" fill="none" className="w-full h-full drop-shadow-md">
    <defs>
      <linearGradient id="weiaiRoseGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FECDD3" />
        <stop offset="50%" stopColor="#F43F5E" />
        <stop offset="100%" stopColor="#9F1239" />
      </linearGradient>
      <linearGradient id="weiaiFoilGold" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FEF08A" />
        <stop offset="50%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
    </defs>
    <rect x="8" y="8" width="84" height="84" rx="22" stroke="url(#weiaiFoilGold)" strokeWidth="2" fill="#1C1917" fillOpacity="0.7" />
    <rect x="13" y="13" width="74" height="74" rx="18" stroke="url(#weiaiFoilGold)" strokeWidth="0.8" strokeDasharray="3 2" />
    <path d="M50 68 C 28 52, 20 36, 26 24 C 32 14, 45 18, 50 28 C 55 18, 68 14, 74 24 C 80 36, 72 52, 50 68 Z" fill="url(#weiaiRoseGold)" stroke="url(#weiaiFoilGold)" strokeWidth="1.2" />
    <path d="M50 24 Q 50 40 66 40 Q 50 40 50 56 Q 50 40 34 40 Q 50 40 50 24 Z" fill="url(#weiaiFoilGold)" />
    <circle cx="50" cy="40" r="3.5" fill="#FFF" />
    <circle cx="36" cy="74" r="2" fill="url(#weiaiFoilGold)" />
    <circle cx="50" cy="78" r="2.5" fill="url(#weiaiFoilGold)" />
    <circle cx="64" cy="74" r="2" fill="url(#weiaiFoilGold)" />
  </svg>
);

// 4. 赤金至尊 (Grand Master) - 皇家太阳星纹
const MasterDragonCrest = () => (
  <svg viewBox="0 0 100 100" fill="none" className="w-full h-full drop-shadow-md">
    <defs>
      <linearGradient id="dragonFoil" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FEF08A" />
        <stop offset="40%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#78350F" />
      </linearGradient>
    </defs>
    <circle cx="50" cy="50" r="44" stroke="url(#dragonFoil)" strokeWidth="2" fill="#451A03" fillOpacity="0.7" />
    <circle cx="50" cy="50" r="39" stroke="url(#dragonFoil)" strokeWidth="0.8" strokeDasharray="2 2" />
    <path d="M50 14 L56 34 L76 34 L60 46 L66 66 L50 54 L34 66 L40 46 L24 34 L44 34 Z" fill="url(#dragonFoil)" />
    <circle cx="50" cy="50" r="8" fill="#FEF08A" />
    <circle cx="50" cy="50" r="5" fill="#78350F" />
  </svg>
);

// 5. 曜石极光 (Obsidian) - 几何电竞棱镜
const ObsidianCrest = () => (
  <svg viewBox="0 0 100 100" fill="none" className="w-full h-full drop-shadow-md">
    <defs>
      <linearGradient id="obsFoil" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#FDE68A" />
        <stop offset="50%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#78350F" />
      </linearGradient>
    </defs>
    <polygon points="50,6 94,50 50,94 6,50" stroke="url(#obsFoil)" strokeWidth="2" fill="#09090B" fillOpacity="0.8" />
    <polygon points="50,14 86,50 50,86 14,50" stroke="url(#obsFoil)" strokeWidth="0.8" strokeDasharray="3 2" />
    <polygon points="50,26 74,50 50,74 26,50" fill="url(#obsFoil)" />
    <circle cx="50" cy="50" r="4" fill="#000" />
  </svg>
);

export const CardBack: React.FC<CardBackProps> = ({
  size = 'md',
  className = '',
  count,
  customSettings,
}) => {
  const [settings, setSettings] = useState<CardBackSettings>(() => customSettings || loadCardBackSettings());

  useEffect(() => {
    if (customSettings) {
      setSettings(customSettings);
      return;
    }

    const handler = () => {
      setSettings(loadCardBackSettings());
    };
    window.addEventListener('cardback_settings_changed', handler);
    return () => window.removeEventListener('cardback_settings_changed', handler);
  }, [customSettings]);

  const preset = CARDBACK_PRESETS.find((p) => p.id === settings.presetId) || CARDBACK_PRESETS[0];

  const sizeClasses = {
    sm: 'w-7.5 h-11 rounded-md',
    md: 'w-11 h-17 sm:w-14 sm:h-21 rounded-lg',
    lg: 'w-16 h-24 sm:w-20 sm:h-30 rounded-xl',
  }[size];

  const emblemSizeClasses = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8 sm:w-11 sm:h-11',
    lg: 'w-12 h-12 sm:w-16 sm:h-16',
  }[size];

  const logoUrl = settings.customLogoUrl;

  const bgGradients = {
    crimson: 'bg-gradient-to-br from-red-950 via-rose-950 to-slate-950 border-amber-400',
    emerald: 'bg-gradient-to-br from-emerald-950 via-teal-950 to-slate-950 border-emerald-400',
    navy: 'bg-gradient-to-br from-blue-950 via-indigo-950 to-slate-950 border-sky-400',
    gold: 'bg-gradient-to-br from-amber-950 via-yellow-950 to-slate-950 border-amber-300',
    obsidian: 'bg-gradient-to-br from-slate-950 via-zinc-900 to-black border-amber-400/80',
  };

  const themeClass = bgGradients[settings.themeColor] || bgGradients.crimson;

  // Render pure vector crest emblem based on preset / theme (NO TEXT on card back)
  const renderEmblem = () => {
    if (logoUrl) {
      return (
        <img
          src={logoUrl}
          alt="CardBack Emblem"
          className="w-full h-full object-contain drop-shadow-md rounded-full border border-amber-300/50"
        />
      );
    }

    const id = settings.presetId;
    if (id === 'naacu' || id === 'nacuaa') return <NacuaaCrest />;
    if (id === 'zju' || id === 'zjuaanc') return <ZjuaancCrest />;
    if (id === 'weiai') return <ViAiCrest />;
    if (id === 'royal_gold') return <MasterDragonCrest />;
    if (id === 'obsidian') return <ObsidianCrest />;

    if (settings.themeColor === 'navy') return <ZjuaancCrest />;
    if (settings.themeColor === 'crimson') return <NacuaaCrest />;
    if (settings.themeColor === 'gold') return <MasterDragonCrest />;
    if (settings.themeColor === 'obsidian') return <ViAiCrest />;
    return <NacuaaCrest />;
  };

  return (
    <div
      className={`relative select-none border-2 p-0.5 shadow-xl flex items-center justify-center overflow-hidden font-sans ${themeClass} ${sizeClasses} ${className}`}
      style={{
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.45), inset 0 0 10px rgba(245, 158, 11, 0.25)',
      }}
    >
      {/* Inner Decorative Golden Inset Border */}
      <div className="w-full h-full border border-amber-400/50 rounded flex flex-col items-center justify-center relative p-0.5 overflow-hidden">
        {/* Subtle Diamond Guilloche Texture Background */}
        <div
          className="absolute inset-0 opacity-25 pointer-events-none"
          style={{
            backgroundImage:
              'radial-gradient(#F59E0B 1px, transparent 1px), radial-gradient(#38BDF8 1px, transparent 1px)',
            backgroundSize: '5px 5px',
            backgroundPosition: '0 0, 2.5px 2.5px',
          }}
        />

        {/* Center Pure Vector Emblem Crest (Zero text for casino elegance) */}
        <div className={`relative flex items-center justify-center drop-shadow-lg ${emblemSizeClasses}`}>
          {renderEmblem()}
        </div>

        {/* Optional Remaining Count Badge */}
        {count !== undefined && (
          <div className="absolute bottom-0.5 bg-amber-500 text-slate-950 font-black text-[8px] sm:text-[9px] px-1 rounded-full shadow border border-amber-200">
            {count}
          </div>
        )}
      </div>
    </div>
  );
};
